<template>
  <vs-popup class="general-popup" :class="{'general-popup-horizontal': horizontal}" title="" :active.sync="popupActive">
    <component v-if="componentName && !componentData" :is="componentName" @hidePopup="popupActive=false"/>
    <component v-if="componentName && componentData" :is="componentName" @hidePopup="popupActive=false" :componentData="componentData"/>
  </vs-popup>
</template>

<script>
import TrialJourneyStarted from '@/views/Self-Improvee/Notifications/TrialJourneyStarted'

export default {
  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    componentName: {
      type: String,
      required: false
    },
    componentData: {
      type: Object,
      required: false
    },
    horizontal: {
      type: Boolean,
      required: false
    },
  },
  components: {
    TrialJourneyStarted
  },
  data () {
   return {
      popupActive: false
    }
  },
  watch: {
    'showPopup': {
      immediate: false,
      handler (showPopup) {
        if (showPopup) {
          this.popupActive = true
        }
      }
    },
    'popupActive': {
      handler (popupActive) {
        if (!popupActive) {
          this.$emit('popupHidden')
        }
      }
    }
  },
  computed: {

  },
  methods: {
  }
}
</script>

<style land="scss">

.general-popup-horizontal .vs-popup {
  width: 80% !important;
}


</style>
